import './app_divider.css';

export default function AppDivider({ height, width, color }) {
  return <div style={{ height, width, backgroundColor: color }} className="app-divider"></div>;
}
